// import axios from 'axios';
import { rootUrl } from '../config';

export const logUserAnalytics = (id) => {
  navigator.sendBeacon(
    `${rootUrl}/api/analytics/page-view`,
    new URLSearchParams({ userId: id })
  );
};
